import { render, staticRenderFns } from "./DriblabSocialMedia.vue?vue&type=template&id=7ad243e4"
import script from "./DriblabSocialMedia.vue?vue&type=script&lang=js"
export * from "./DriblabSocialMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports